<template>
    <CList :pConfigList="ConfigList" :segurity="segurity">
        <template slot="bodyForm">
            <CLoader :pConfigLoad="ConfigLoad">
                <template slot="BodyFormLoad">
                    <div class="container-fluid">
                        <form id="FormAsignarPermisosUsuario" role="form" method="post" autocomplete="off"
                            onSubmit="return false">
                            <div class="row">
                                <div class="col-auto">
                                    <label class="col-form-label mr-1">Menus: </label>
                                </div>
                                <div class="col-auto">
                                    <select v-model="MenuxUsuario.IdMenu" @change="ObtenerMenuActivo()"
                                        class="form-control form-select form-control-search">
                                        <option value="0">Seleccione una opción</option>
                                        <option v-for="(lista, index) in ListaMenus" :key="index"
                                            :value="lista.IdPanel">
                                            {{ lista.Nombre }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-auto" v-show="ShowActiveMenu">
                                    <button type="button" @click="ActivarMenu(Button.Status);" :class="Button.Class"
                                        :disabled="DisabledMenu"
                                        style="padding-block: 0.625rem; padding-inline: 1.25rem; font-size: 0.875rem;">
                                        <i :class="Button.Icon"></i> {{ Button.Text }}
                                    </button>
                                </div>
                            </div>
                            <div class="form-group row">


                            </div>

                            <!-- <div class="row mt-5" v-show="MenuxUsuario.IdMenu == 0">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                    <h1>Seleccione un Menú</h1>
                                </div>
                            </div> -->

                            <div class="row mt-3" v-show="ShowActiveSubMenu">
                                <CLoader :pConfigLoad="ConfigLoadMenus">
                                    <template slot="BodyFormLoad">
                                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                                            <li class="nav-item" role="presentation" v-show="ShowDivSubMenu">
                                                <button class="nav-link active" id="submenu-tab" data-bs-toggle="tab"
                                                    data-bs-target="#submenu-tab-pane" type="button" role="tab"
                                                    aria-controls="submenu-tab-pane" aria-selected="true">Submenú</button>
                                            </li>
                                            <li class="nav-item" role="presentation" v-show="ShowDivSubMenu">
                                                <button class="nav-link" id="apartado-tab" data-bs-toggle="tab"
                                                    data-bs-target="#apartado-tab-pane" type="button" role="tab"
                                                    aria-controls="apartado-tab-pane"
                                                    aria-selected="false">Apartados</button>
                                            </li>
                                            <li class="nav-item" role="presentation" v-show="ShowDivSubMenu">
                                                <button class="nav-link" id="subapartado-tab" data-bs-toggle="tab"
                                                    data-bs-target="#subapartado-tab-pane" type="button" role="tab"
                                                    aria-controls="subapartado-tab-pane"
                                                    aria-selected="false">Subapartado</button>
                                            </li>
                                            <li class="nav-item" role="presentation" v-show="!ShowDivSubMenu">
                                                <button class="nav-link" id="permisos-tab" data-bs-toggle="tab" data-bs-target="#permisos-tab-pane" type="button" role="tab" aria-controls="permisos-tab-pane" aria-selected="false">Permisos</button>
                                            </li>
                                        </ul>
                                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                            <div class="tab-content" id="myTabContent">
                                                <div class="tab-pabe fade show active" id="submenu-tab-pane"
                                                    role="tabpanel" aria-labelledby="submenu-tab" tabindex="0">
                                                    <Dependiente :pArreglo="ListaSubMenus" :pObjMenu="MenuxUsuario"
                                                        ref="child" :p="ShowDivSubMenu" :pLimpiar="BndLimpia">
                                                    </Dependiente>
                                                </div>

                                                <div class="tab-pane fade" id="apartado-tab-pane" role="tabpanel"
                                                    aria-labelledby="apartado-tab" tabindex="0">
                                                    <Dependiente :pArreglo="ListaApartados" :pObjMenu="MenuxUsuario"
                                                        ref="child" :pShowDivSubMenu="ShowDivSubMenu"
                                                        :pLimpiar="BndLimpia">
                                                    </Dependiente>
                                                </div>

                                                <div class="tab-pane fade" id="subapartado-tab-pane" role="tabpanel"
                                                    aria-labelledby="subapartado-tab" tabindex="0">
                                                    <Dependiente :pArreglo="ListaSubApartados" :pObjMenu="MenuxUsuario"
                                                        ref="child" :pShowDivSubMenu="ShowDivSubMenu"
                                                        :pLimpiar="BndLimpia">
                                                    </Dependiente>
                                                </div>

                                                <div class="tab-pane fade" id="permisos-tab-pane" role="tabpanel"
                                                    aria-labelledby="permisos-tab" tabindex="0">
                                                    <div class="container-fluid">
                                                        <Dependiente :pObjMenu="MenuxUsuario" ref="child"
                                                            :pShowDivSubMenu="ShowDivSubMenu"></Dependiente>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </CLoader>
                            </div>

                        </form>
                    </div>
                </template>
            </CLoader>
        </template>
    </CList>

</template>

<script>

import Configs from '@/helpers/VarConfig.js';
import Dependiente from './menuDependiente.vue';
const ButtonStyles = {
    Activate: {
        Class: 'btn mb-0 btn-sm btn-primary',
        Icon: 'far fa-check',
        Text: 'Activar menú',
        Status: 1,
    },
    Deactivate: {
        Class: 'btn mb-0 btn-sm btn-danger',
        Icon: 'far fa-ban',
        Text: 'Desactivar menú',
        Status: 0,
    }
}
export default {
    name: 'FormAsignarPermisosUsuario',
    props: ['pObjUsuario'],
    components: { Dependiente },
    data() {
        return {
            ConfigList: {
                TitleFirst: 'Asignar Permisos',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                ShowTitleFirst: true,
                TypeBody: 'Form',
                Title: '',
                // EmitSeccion: EmitEjecuta,
            },
            ConfigLoad: {
                ShowLoader: false,
                ClassLoad: false,
            },
            ConfigLoadMenus: {
                ShowLoader: false,
                ClassLoad: true,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'empleados',
                // EmitSeccion: EmitEjecuta,
            },
            ObjUsuario: {},
            MenuxUsuario: {
                IdMenu: 0,
                IdUsuario: 0,
            },
            Button: { ...ButtonStyles.Activate },
            ShowActiveMenu: false,
            ShowActiveSubMenu: false,
            ShowDivSubMenu: true,
            DisabledMenu: false,
            BndLimpia: false,
            ListaMenus: [],
            ListaSubMenus: [],
            ListaApartados: [],
            ListaSubApartados: [],
            IdUsuario: 0,
            TimeOutMenuChange: null,
            segurity: {},
            errorvalidacion: [],
        }
    },
    methods:
    {
        Recuperar() {
            this.$http.get(
                "asignarPermisosUsuario/" + this.IdUsuario
            ).then((res) => {

            }).finally(() => {
                this.ConfigLoad.ShowLoader = false;
            }).catch((err) => {
            });
        },
        Regresar() {
            this.$router.push({ name: this.oBtnSave.ReturnRoute, params: {} });
        },
        Limpiar() {
            this.errorvalidacion = [];
        },

        async ListarMenus() {
            await this.$http.get('usuariosxPermiso', {
                params: {
                    IdUsuario: this.ObjUsuario.IdUsuario,
                    TipoMenu: 'Menu'
                }
            }).then((res) => {
                this.ListaMenus = res.data.data;
            }).finally(() => {
                this.ConfigLoad.ShowLoader = false;
                // this.ConfigList.ShowLoader = false;
            });
        },
        // OBTENEMOS EL ESTATUS DEL BOTON DE MENUS PARA SABER SI ESTA ACTIVO O NO
        ObtenerMenuActivo() {
            this.ConfigLoadMenus.ShowLoader = true;
            let IdMenu = this.MenuxUsuario.IdMenu
            this.ShowActiveMenu = false;
            this.ShowActiveSubMenu = false;

            // SI HAY ALGUN MENU SELECCIONADO OBTENEMOS SU ARREGLO Y REVISAMOS SI SU BOTON ESTA ACTIVADO O DESACTIVADO
            if (IdMenu > 0) {
                this.ShowActiveMenu = true;
                this.ShowActiveSubMenu = true;
                let ObjMenu = this.FiltrarArreglo(IdMenu);

                // SI TIENE EXISTE EL MENU ACTIVO ENTONCES SE SETEA COMO BOTON DESACTIVAR SINO COMO ACTIVAR
                if (ObjMenu.Existe > 0) {
                    this.CambiaEstatusBotonMenu(0);
                } else {
                    this.CambiaEstatusBotonMenu(1);
                }

            } else {
                this.ListaSubMenus = [];
                this.ListaApartados = [];
                this.ListaSubApartados = [];
                this.BndLimpia = true;
                this.ShowActiveMenu = false;
                this.ShowActiveSubMenu = false;
            }
            clearTimeout(this.TimeOutSearch);
            this.TimeOutSearch = setTimeout(() => {
                this.ConfigLoadMenus.ShowLoader = false;
            }, 500);
        },
        FiltrarArreglo(Id) {
            let arr = this.ListaMenus.filter(function (item, index) {
                if (item.IdPanel == Id) {
                    return item;
                } else {
                    return '';
                }
            });

            if (arr[0]) {
                return arr[0];
            }

        },
        // ESTABLECEMOS LOS TEXTOS Y COLOR DEL BOTON DE MENUS
        CambiaEstatusBotonMenu(Tipo) {
            this.BndLimpia = true;
            // 1 PARA CUANDO SEA ACTIVAR EL BOTON Y 0 PARA CUANDO SEA DESACTIVAR EL BOTON
            if (Tipo == 0) {
                this.Button = { ...ButtonStyles.Deactivate };
                this.ShowActiveSubMenu = true;
            } else {
                this.Button = { ...ButtonStyles.Activate };
                this.ShowActiveSubMenu = false;
            }
            this.ObtenerDependientesMenu();
        },
        // MANDAMOS A GUARDAR EL MENU EN EL USUARIO
        ActivarMenu(accion) {
            var txtOrigen = this.Button.Text;
            var icoOrigen = this.Button.Icon;
            this.DeshabilitarBotonMenu(true, txtOrigen, icoOrigen);

            let ObjSend = {
                IdMenu: this.MenuxUsuario.IdMenu,
                IdUsuario: this.MenuxUsuario.IdUsuario,
                BtnAccion: accion,
                TipoMenu: 'Menu'
            };

            this.ConfigLoadMenus.ShowLoader = true;
            this.$http.post(
                'usuariosxPermiso', ObjSend
            ).then((res) => {
                this.DeshabilitarBotonMenu(false, txtOrigen, icoOrigen);

                if (res.data.exist > 0) {
                    let ObjMenu = this.FiltrarArreglo(this.MenuxUsuario.IdMenu);

                    if (accion == 0) {
                        ObjMenu.Existe = 0;
                        this.CambiaEstatusBotonMenu(1);
                    } else {
                        ObjMenu.Existe = 1;
                        this.CambiaEstatusBotonMenu(0);
                    }
                } else {
                    this.$toast.error(err.response.data.message);
                }
            }).finally(() => { this.ConfigLoadMenus.ShowLoader = false }
            ).catch((err) => {
                this.$toast.error(err.response.data.message);
            });
        },
        ObtenerDependientesMenu() {
            this.ShowDivSubMenu = true;
            this.$http.get('usuariosxPermiso/dependientes', {
                params: {
                    IdMenu: this.MenuxUsuario.IdMenu,
                    IdUsuario: this.MenuxUsuario.IdUsuario
                }
            }
            ).then((res) => {
                this.ListaSubMenus = res.data.SubMenus;
                this.ListaApartados = res.data.Apartados;
                this.ListaSubApartados = res.data.SubApartados;
                this.CrearBotones(this.ListaSubMenus);
                this.CrearBotones(this.ListaApartados);
                this.CrearBotones(this.ListaSubApartados);

                // SINO RECIBE NINGUN DEPENDIENTE, SOLO MUESTRA LOS PERMISOS DE ESE APARTADO
                if (this.ListaSubMenus.length == 0 && this.ListaApartados.length == 0 && this.ListaSubApartados.length == 0) {
                    this.ShowDivSubMenu = false;
                    this.SeleccionarTab('permisos-tab')
                    let ObjMenu = this.FiltrarArreglo(this.MenuxUsuario.IdMenu);
                    this.$refs.child.MostrarPermisosxMenu(this.MenuxUsuario.IdMenu, ObjMenu);
                } else {
                    // Targeteamos el último tab seleccionado
                    let arrTabs = document.querySelectorAll('button[role="tab"]');
                    let ulitmoTab = {id:'submenu-tab'} //por defecto
                    arrTabs.forEach(elem => {
                        if(elem.getAttribute('aria-selected') == 'true'&&elem.id!='permisos-tab') ulitmoTab = elem;
                    })
                    this.SeleccionarTab(ulitmoTab.id) // último seleccionado
                    
                }
            });
        },
        SeleccionarTab(tabName){
            let tabsPaneIds = ['submenu-tab','apartado-tab','subapartado-tab','permisos-tab'];
            tabsPaneIds.forEach(elem=>{
                let elemTab = document.getElementById(elem)
                let elemPane = document.getElementById(elem+'-pane');
                
                elemTab.setAttribute('aria-selected','false');
                elemTab.setAttribute('class','nav-link');
                elemPane.setAttribute('class','tab-pane fade');
            })
            
            let targetTab = document.getElementById(tabName)
            let targetPane = document.getElementById(tabName+'-pane');
            targetTab.setAttribute('aria-selected','true');
            targetTab.setAttribute('class','nav-link active');
            targetPane.setAttribute('class','tab-pane fade active show');
        },
        CrearBotones(arr) {
            arr.forEach(elem => {
                let button = {}
                if (elem.Activado) {
                    button = { ...ButtonStyles.Deactivate };
                } else {
                    button = { ...ButtonStyles.Activate };
                }
                elem['button'] = button;
            });
        },
        DeshabilitarBotonMenu(bnd, txt, ico) {
            this.DisabledMenu = false;
            this.Button.Text = txt;
            this.Button.Icon = ico;

            if (bnd) {
                this.DisabledMenu = true;
                this.Button.Text = ' Espere...';
                this.Button.Icon = 'fa fa-spinner fa-pulse';
            }

        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        if (this.pObjUsuario != undefined) {
            sessionStorage.setItem('oUsuario', JSON.stringify(this.pObjUsuario));
        }

        this.ObjUsuario = JSON.parse(sessionStorage.getItem('oUsuario'));
        this.ConfigList.Title = this.ConfigList.Title = this.ObjUsuario.Nombre;
        this.MenuxUsuario.IdUsuario = this.ObjUsuario.IdUsuario;
        this.ShowDivSubMenu = true;
        this.bus.$off('EmitReturn');
        this.bus.$off('RefrescaVista');
        this.bus.$off('StopLoader');
    },
    mounted() {
        this.Limpiar();
        this.ListarMenus();
        this.bus.$on('EmitReturn', () => {
            this.Regresar();
        });
        this.bus.$on('RefrescaVista', () => {
            this.ObtenerDependientesMenu();
        });
    }
}
</script>
